module.exports = __webpack_public_path__ + "static/media/18.a6c0aff8.jpg";